import { SupportView } from '../../UserSupportDialog'
import { UserSupportFormCategory } from './useUserSupportMetadata'

const PHONE_HINT = 'Vi bruker kun dette hvis vi trenger å ringe deg for en oppklaring'
const EMAIL_HINT = 'Vi bruker dette for å kontakte deg om henvendelsen'

type UserFeedbackFormConfig = {
    category: UserSupportFormCategory
    labels: {
        subject: string
        description: string
    }
    hints: {
        subject: string
        description: string
        email: string
        phone: string
    }
    successToast: string
}

export const formByView: Record<Exclude<SupportView, 'menu'>, UserFeedbackFormConfig> = {
    bugReport: {
        category: 'bug report',
        labels: {
            subject: 'Tittel',
            description: 'Beskrivelse av feilen',
        },
        hints: {
            subject: 'En kort overskrift som beskriver feilen',
            description: 'Beskriv hva som skjedde og hva du forventet skulle skje',
            phone: PHONE_HINT,
            email: EMAIL_HINT,
        },
        successToast: 'Feilrapporten er sendt. Takk!',
    },
    helpRequest: {
        category: 'user support',
        labels: {
            subject: 'Tittel',
            description: 'Hva lurer du på?',
        },
        hints: {
            subject: 'Beskriv kort hva du trenger hjelp med',
            description: 'Beskriv hva du trenger hjelp med, så svarer vi så raskt vi kan',
            phone: PHONE_HINT,
            email: EMAIL_HINT,
        },
        successToast: 'Henvendelsen er sendt. Takk!',
    },
    changeRequest: {
        category: 'suggestion',
        labels: {
            subject: 'Tittel',
            description: 'Beskrivelse',
        },
        hints: {
            subject: 'Beskriv kort hva forslaget handler om',
            description: 'Beskriv forslaget, hvorfor det er nyttig og hvordan det kan løses',
            phone: PHONE_HINT,
            email: EMAIL_HINT,
        },
        successToast: 'Forslaget er sendt. Takk!',
    },
}
